import React from 'react';
import { ComponentStory, ComponentMeta } from '@storybook/react';
import Label from './index';

export default {
  title: 'Atoms/Labels',
  component: Label
} as ComponentMeta<typeof Label>;

const Template: ComponentStory<typeof Label> = args => {
  return <Label {...args} />;
};

export const LabelDefault = Template.bind({});
LabelDefault.args = {
  text: 'Thé',
  className: 'root',
  backgroundColor: '#AAD071B2'
};
export const LabelWithoutBG = Template.bind({});
LabelWithoutBG.args = {
  text: 'Thé',
  className: 'root'
};
